import React from "react";
import { useApp } from "../../../hooks/useApp.js";
import { useTotals } from "../../../hooks/useTotals.js";
import { money } from "../../../utils/format.js";

const TicketPanel = () => {
  const { state } = useApp();
  const t = useTotals();

  // Weight-amended returns carry their vehicles in amendVehicles, not the
  // return's regular vehicle list - reportedVehicleCnt/taxableVehicleCnt
  // legitimately come back 0 from the backend for this filing type (every
  // TGW-increase worksheet row is a taxable vehicle, none suspended), so
  // reported/taxable are derived from amendVehicles.length here instead.
  const isWeightAmended = state.returnType === "amended" && state.amendReason === "weight";
  const isVinCorrection = state.returnType === "vincorrection";
  const reported = isWeightAmended ? state.amendVehicles.length : t.reported;
  const taxable = isWeightAmended ? state.amendVehicles.length : t.taxable;
  const suspended = isWeightAmended ? 0 : t.suspended;

  return (
    <div className="ticket-perf sticky top-[92px] overflow-hidden bg-[var(--ticket)] border border-[var(--line)] rounded-[var(--r)] shadow-[var(--shadow)]">
      <div className="p-[22px_20px_20px]">
        <div className="font-disp uppercase tracking-[.12em] text-xs text-[var(--muted)] mb-3">Scale ticket · live</div>

        {isVinCorrection ? (
          <Row label="Vehicles corrected" value={state.correctedVins.length} />
        ) : (
          <>
            <Row label="Reported trucks" value={reported} />
            <Row label="Taxable" value={taxable} />
            <Row label="Suspended" value={suspended} />
          </>
        )}
        <Row label="Tax (line 2)" value={money(t.line2)} />

        <div className="flex justify-between items-baseline mt-3.5 pt-3 border-t-2 border-[var(--ink)]">
          <span className="font-disp uppercase tracking-[.08em] text-[13px]">Balance due</span>
          <b className="font-mono text-2xl font-semibold">{money(t.line6)}</b>
        </div>

        <div className="inline-flex items-center gap-1.5 text-[11px] text-[var(--accent)] font-semibold uppercase tracking-[.08em] mt-3 before:content-[''] before:w-[7px] before:h-[7px] before:rounded-full before:bg-[var(--accent)] before:animate-blink">
          Updates as you go
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="flex justify-between items-baseline py-[9px] border-b border-dashed border-[var(--line-2)] text-sm">
    <span className="text-[var(--muted)]">{label}</span>
    <b className="font-mono font-medium">{value}</b>
  </div>
);

export default TicketPanel;
